import { userManager } from '../../userManager';

/**
 * useGetUserIDP needed a separate function in order to correctly mock this value in tests
 * Unless you need to mock userManager?.idps?.last, you likely won't need to call this function
 */
const getLastIdp = (): string | null => userManager?.idps?.last;

export default getLastIdp;
